var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinterest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16,0C7.16,0,0,7.16,0,16c0,6.78,4.22,12.57,10.17,14.9-.14-1.27-.27-3.21.06-4.59.29-1.25,1.88-7.95,1.88-7.95,0,0-.48-.96-.48-2.38,0-2.22,1.29-3.89,2.9-3.89,1.37,0,2.02,1.02,2.02,2.25,0,1.37-.87,3.43-1.33,5.33-.38,1.59.8,2.89,2.37,2.89,2.84,0,5.03-3,5.03-7.33,0-3.83-2.75-6.51-6.68-6.51-4.55,0-7.22,3.41-7.22,6.94,0,1.38.53,2.85,1.19,3.65.13.16.15.3.11.46-.12.51-.39,1.59-.44,1.81-.07.29-.23.36-.54.21-2-.93-3.25-3.85-3.25-6.2,0-5.05,3.67-9.68,10.57-9.68,5.55,0,9.86,3.96,9.86,9.24s-3.48,9.95-8.3,9.95c-1.62,0-3.15-.84-3.67-1.84,0,0-.8,3.05-1,3.8-.36,1.39-1.34,3.13-1.99,4.19,1.5.46,3.09.71,4.74.71,8.84,0,16-7.16,16-16S24.84,0,16,0",
    fill: "#e60023"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.c1d9f1b76e9b7fbdc2077b3c43fe81b8.svg";
export { ForwardRef as ReactComponent };